import * as actions from './actions';
import { isLocalStorageAvailable } from '../../utility/utils';

const initialState = {
	collapsed: (isLocalStorageAvailable() && JSON.parse(localStorage.getItem('collapsed'))) || false,
	notifications: {
		badges: {}
	}
};

function localStorageHandler(collapsed) {
	if (isLocalStorageAvailable()) {
		localStorage.setItem('collapsed', collapsed);
	}
}

function reducetoggleNavCollapsed(state) {
	localStorageHandler(!state.collapsed);
	return {
		...state,
		collapsed: !state.collapsed
	};
}

function reduceUpdateNavigationBadge(state, badge) {
	if (badge.severity === 'none') {
		// clear the badge
		const badges = {
			...state.notifications.badges
		};
		delete badges[badge.name];
		return {
			...state,
			notifications: {
				...state.notifications,
				badges
			}
		};
	}
	// set badge state
	return {
		...state,
		notifications: {
			...state.notifications,
			badges: {
				...state.notifications.badges,
				[badge.name]: {
					type: badge.severity,
					count: badge.label
				}
			}
		}
	};
}

export const navigation = (state, action) => {
	state = state || initialState;
	switch (action.type) {
		case actions.TOGGLE_NAV_COLLAPSED:
			return reducetoggleNavCollapsed(state);
		case actions.UPDATE_NAVIGATION_BADGE:
			return reduceUpdateNavigationBadge(state, action.payload);
		default:
			return state;
	}
};
